import moment from "moment";

export default {
    formatDate(date) {
        return date ? moment(date).format("DD/MM/yyyy") : 'Data não encontrada';
    },
    displayValue(date, dv) {
        return date ? moment(date).format("DD/MM/yyyy") : (dv || '');
    }
}